import React, { useEffect } from 'react';
import { Link } from 'react-router';

import { track } from 'apis/amethyst';
import { evSearchAdClick, evSearchAdView } from 'events/search';
import useMartyContext from 'hooks/useMartyContext';
import Card from 'components/common/card/Card';
import CardMedia from 'components/common/card/CardMedia';

import { details, mainText, productLink, subText } from 'styles/components/common/productCard.scss';

const InlineProductCardAd = props => {
  const {
    className,
    mobilesrc,
    src,
    link,
    heading,
    subheading,
    term,
    placement
  } = props;

  const { testId } = useMartyContext();

  const mediaProps = {
    mainImage: {
      src,
      srcSet: `${mobilesrc} 1x, ${src} 2x`
    },
    fullSizeImage: true,
    imageNoBackground: true
  };
  const productLabel = `${heading} ${subheading}`;

  const cardClick = () => {
    track(() => ([
      evSearchAdClick, { adLocation: 'SEARCH_RESULTS', searchTerm: term, advertisementType: 'INLINE_SYMPHONY_AD', endpoint: link }
    ]));
  };

  useEffect(() => {
    track(() => ([
      evSearchAdView, { adLocation: 'SEARCH_RESULTS', searchTerm: term, advertisementType: 'INLINE_SYMPHONY_AD', endpoint: link }
    ]));
  }, [term, placement, link]);

  return (
    <Card className={className}>
      <Link
        className={productLink}
        onClick={cardClick}
        to={link}
        itemProp="url"
        data-test-id={testId('inlineProductAdLink')}>
        {productLabel}
      </Link>
      <CardMedia {...mediaProps}/>
      <dl className={details}>
        <dt>Title</dt>
        <dd className={mainText}>{heading}</dd>
        { subheading && (
          <>
            <dt>Description</dt>
            <dd className={subText}>{subheading}</dd>
          </>
        )}
      </dl>
    </Card>
  );
};

export default InlineProductCardAd;
